import { defineMessages } from 'react-intl';

export default defineMessages({
    save: {
        id: '_.your_company.prompt.save',
        defaultMessage: 'Save'
    },
    cancel: {
        id: '_.your_company.prompt.cancel',
        defaultMessage: 'Cancel'
    }
});
